import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useAuthStore } from '../stores/root_store';

interface AuthorNameProps {
  name: string;
  userUuid?: string;
  variant?: 'body1' | 'body2' | 'subtitle2' | 'caption';
  fontWeight?: number;
}

export const AuthorName = ({
  name,
  userUuid,
  variant = 'body2',
  fontWeight,
}: AuthorNameProps) => {
  const authStore = useAuthStore();
  const isManager = authStore.roles.includes('manager');

  if (isManager && userUuid) {
    return (
      <Typography
        component={Link}
        to={`/manager/user/${userUuid}`}
        variant={variant}
        sx={{
          fontWeight,
          color: 'primary.main',
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        {name}
      </Typography>
    );
  }

  return (
    <Typography variant={variant} component="span" sx={{ fontWeight }}>
      {name}
    </Typography>
  );
};
